import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared.module';

@Component({
    selector: 'farm-field-splits',
    templateUrl: 'farm-field-splits.component.html',
    standalone: true, // Required for Angular 18's new standalone components
    imports: [
        SharedModule,
        MaterialModule
    ],
})

export class FarmAndFieldSplitsComponent {
    splits: any;
    Error: string;
    name: string;
    isDifferentLocationItemSelected: boolean;
    displayedColumns: string[] = [
        "SplitClientIdDV",
        "FertilizerPercent",
        "ChemicalPercent",
        "SeedPercent",
        "ServicePercent",
        "LimePercent"
    ];
    @Output() sendResponseEventEmitter = new EventEmitter<any>();
    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
        if (data) {
            this.splits = data.splits;
            this.name = data.name;
            this.isDifferentLocationItemSelected = data.isDifferentLocationItemSelected;
            if (Array.isArray(this.splits) && this.splits.length > 0) {
            }
            else {
                this.Error = 'There are no splits to display.';
            }
        }
    }
    getColumName(columnName) {
        switch (columnName) {
            case "SplitClientIdDV":
                return 'Name';
            case "FertilizerPercent":
                return 'Fert';
            case "ChemicalPercent":
                return 'Chem';
            case "SeedPercent":
                return 'Seed';
            case "ServicePercent":
                return 'Serv'
            case "LimePercent":
                return 'Lime';
        }
    }
}